<template>
  <transition name="loader-fade">
    <div v-if="show" class="loader-wrapper" :class="loaderModeClass">
      <div class="loader-aurora" aria-hidden="true"></div>

      <div class="loader-container">
        <div class="loader-glass-disc" aria-hidden="true">
          <div class="loader-glass-disc__shine"></div>
        </div>

        <div class="loader-spinner">
          <div class="spinner-ring spinner-ring--outer"></div>
          <div class="spinner-ring spinner-ring--mid"></div>
          <div class="spinner-ring spinner-ring--inner"></div>
          <div class="spinner-center">
            <div class="center-pulse"></div>
            <div class="center-glow" aria-hidden="true"></div>
          </div>
        </div>

        <div class="loader-particles" aria-hidden="true">
          <div
            v-for="i in 12"
            :key="i"
            class="particle"
            :class="`particle-${i}`"
            :style="{ '--delay': (i - 1) * 0.1 + 's' }"
          ></div>
        </div>
      </div>

      <p v-if="text" class="loader-text">
        <span class="loader-text__content">{{ text }}</span>
      </p>
    </div>
  </transition>
</template>

<script>
import './HourglassLoader.css';

export default {
  name: 'HourglassLoader',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: 'Loading...'
    },
    mode: {
      type: String,
      default: 'fullscreen',
      validator: value => ['fullscreen', 'contained'].includes(value)
    }
  },
  computed: {
    loaderModeClass() {
      return this.mode === 'contained' ? 'loader-wrapper--contained' : 'loader-wrapper--fullscreen';
    }
  }
}
</script>
